module.exports = __webpack_public_path__ + "img/071.c2e814c0.png";